import React, { useCallback, useEffect, useMemo, useState } from 'react';
import i18n from 'i18n';
import { Modal } from 'components/Modal/Modal';
import { Slider } from 'components/Slider/Slider';
import { DefaultSliderModel } from 'components/Slider/SliderModel';
import styles from './campaignDashboardWalkthrough.module.scss';
import panel1 from 'assets/campaign-dashboard-walkthrough/panel-1-performance.png';
import panel2 from 'assets/campaign-dashboard-walkthrough/panel-2-end-time.png';
import panel3 from 'assets/campaign-dashboard-walkthrough/panel-3-ad-type.png';
import panel4 from 'assets/campaign-dashboard-walkthrough/panel-4-ad-status.png';
import panel5 from 'assets/campaign-dashboard-walkthrough/panel-5-needs-adjust.png';
import panel6 from 'assets/campaign-dashboard-walkthrough/panel-6-query.png';
import panel7 from 'assets/campaign-dashboard-walkthrough/panel-7-list-column.png';

const PANELS: string[] = [panel1, panel2, panel3, panel4, panel5, panel6, panel7];
const PANEL_WIDTH = 1280;
const PANEL_HEIGHT = 720;

export type CampaignDashboardWalkthroughProps = {
  onDismiss: () => void;
};

export const CampaignDashboardWalkthrough: React.FC<CampaignDashboardWalkthroughProps> = ({
  onDismiss
}) => {
  const [index, setIndex] = useState(0);

  const sliderModel = useMemo(
    () => new DefaultSliderModel(PANEL_WIDTH, PANEL_HEIGHT, true, false, 0, false),
    []
  );

  useEffect(() => {
    const handler = sliderModel.event.add((model) => setIndex(model.state.index));
    return () => {
      sliderModel.event.remove(handler);
    };
  }, [sliderModel]);

  const goPrev = useCallback(() => {
    if (sliderModel.state.index > 0) {
      sliderModel.handleSelect(sliderModel.state.index - 1);
    }
  }, [sliderModel]);

  const goNext = useCallback(() => {
    if (sliderModel.state.index < PANELS.length - 1) {
      sliderModel.handleSelect(sliderModel.state.index + 1);
    }
  }, [sliderModel]);

  const isFirst = index === 0;
  const isLast = index === PANELS.length - 1;

  return (
    <Modal
      title={i18n.t<string>('campaignDashboardWalkthrough.modalTitle')}
      className={`modal ${styles.walkthroughModal}`}
      enableCloseBtn={isLast}
      enforceFocus
      backdrop='static'
      dismiss={onDismiss}
    >
      <div className={styles.walkthrough}>
        <Slider
          model={sliderModel}
          itemGap={0}
          prevIconClassName={isFirst ? styles.hiddenArrow : undefined}
          nextIconClassName={isLast ? styles.hiddenArrow : undefined}
        >
          {PANELS.map((src, i) => (
            <div key={i} className={styles.panel}>
              <img src={src} alt={`panel-${i + 1}`} className={styles.image} />
              <div className={styles.leftHalf} onClick={goPrev} />
              <div className={styles.rightHalf} onClick={goNext} />
            </div>
          ))}
        </Slider>
      </div>
    </Modal>
  );
};
